import { createAction } from '@reduxjs/toolkit';

export const LOCAL_STORAGE_LOAD = 'localStorage/load';
export const LOCAL_STORAGE_LOADED = 'localStorage/loaded';
export const LOCAL_STORAGE_SAVE = 'localStorage/save';
export const LOCAL_STORAGE_SAVED = 'localStorage/saved';

export interface ILocalStorageData {
  jwt?: string | null;
  states?: Record<string, unknown>;
}

export const LocalStorageLoad = createAction(LOCAL_STORAGE_LOAD);
export const LocalStorageLoaded = createAction<ILocalStorageData>(LOCAL_STORAGE_LOADED);
export const LocalStorageSave = createAction<ILocalStorageData>(LOCAL_STORAGE_SAVE);
export const LocalStorageSaved = createAction(LOCAL_STORAGE_SAVED);
